var map = {
	"./de.json": 9464,
	"./en-GB.json": 2501,
	"./en.json": 4510,
	"./es.json": 8901,
	"./fr.json": 119,
	"./it.json": 7640,
	"./pl.json": 7958,
	"./pt.json": 6571,
	"./sv.json": 8537,
	"./uk.json": 5954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5511;